import React, { Fragment, useEffect, useState } from "react";
import styles from "./Landing.module.css";
import Header from "../../Components/Layout/Header";
import main_bg from "../../Assets/landing/Main Picture.jpg";
import framing from "../../Assets/landing/framing.webp";
import printing from "../../Assets/landing/print.webp";
import memorabilia from "../../Assets/landing/Memorabillia.webp";
import exhibition from "../../Assets/landing/gallery for website.webp";
import satisfaction from "../../Assets/Satisfaction Garanteed.png";
import delivery from "../../Assets/Delivery.png";
import customer from "../../Assets/Customer Service.png";
import trusted from "../../Assets/Trusted by expert.png";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  IconButton,
  TextField,
  styled,
  Backdrop,
} from "@mui/material";
import artwall from "../../Assets/landing/Art Wall Logo.webp";
import panorama from "../../Assets/landing/FaamGalleryInteriorView.webp";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import bonhams from "../../Assets/landing/Bonhams.png";
import rws from "../../Assets/landing/Royal Society of Watercolour.webp";
import trailfinders from "../../Assets/landing/trailfinders rugby b&W.webp";
import rosberys from "../../Assets/landing/Roseberys Auction.png";
import ladyki from "../../Assets/landing/ladyko.png";
import dhl from "../../Assets/landing/DHL.png";
import christies from "../../Assets/landing/Christie's.png";
import ironmaiden from "../../Assets/landing/iron Maiden.png";
import octink from "../../Assets/landing/Octink.png";
import Footer from "../../Components/Layout/Footer";
import { Link } from "react-router-dom";
import video from "../../Assets/landing/FaamGallery Opening Exhibition 26.mp4";
import Parse from "../../API/ParseServer";
import ClearIcon from "@mui/icons-material/Clear";
import ArtworkCard from "../../Components/ArtworkCard/ArtworkCard";
import { motion } from "motion/react";
import { Fade } from "react-slideshow-image";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { useCart } from "../../Context/CartContext";
import TextType from "../../Components/UI/TextType";
import { ChromaGrid } from "../../Components/UI/BlogChromaGrid";
import LogoLoop from "../../Components/UI/LogoLoop";
import { useSectionScrollSnap } from "../../Hooks/useSectionScrollSnap";
const indicators = (index: any) => <li className={styles.indicator}></li>;
const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};
const Landing = () => {
  const [artworks, setArtworks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [details, setDetails] = useState("");
  const [exhibitions, setExhibitions] = React.useState<any[]>([]);
  const [blogs, setBlogs] = React.useState<any[]>([]);
  const [blogItems, setBlogItems] = useState<any[]>([]);
  const [basket, setBasket] = useState();
  const [modal, setModal] = React.useState("");
  const [artworkQuantities, setArtworkQuantities] = useState();
  const [slider, setSlider] = useState<any>();
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };

  const validEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const validMobile =
    /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  const formSubmitHandler = async (event: any) => {
    event.preventDefault();
    switch (modal) {
      case "Artist Application":
        if (!(email && name && mobile))
          setErrorMessage("Please fill in every required field");
        else if (!validEmail.test(String(email)))
          setErrorMessage("Invalid email address");
        else if (!validMobile.test(String(mobile)))
          setErrorMessage("Invalid phone number");
        else {
          setLoading(true);
          setErrorMessage("");
          try {
            // Create a new instance of the "Form" class
            const Form = Parse.Object.extend("Form");
            const form = new Form();

            // Set the form data
            form.set("type", "Artist Application");
            form.set("userName", name);
            form.set("userEmail", email);
            form.set("userMobile", mobile);
            form.set("details", details);

            form.set("status", "new");

            // Save the form data to Parse Server
            await form.save();
            setName("");
            setEmail("");
            setMobile("");
            setDetails("");
            setErrorMessage("Your information has been successfully submitted");
          } catch (error: any) {
            console.error("Error submitting form:", error);
            setErrorMessage(error.message);
          } finally {
            setLoading(false);
            // setModal("");
          }
        }
        break;
      case "Collector Application":
        if (!(email && name && mobile))
          setErrorMessage("Please fill in every required fiels");
        else if (!validEmail.test(String(email)))
          setErrorMessage("Invalid email address");
        else if (!validMobile.test(String(mobile)))
          setErrorMessage("Invalid phone number");
        else {
          setLoading(true);
          setErrorMessage("");

          try {
            // Create a new instance of the "Form" class
            const Form = Parse.Object.extend("Form");
            const form = new Form();

            // Set the form data
            form.set("type", "Collector Application");
            form.set("userName", name);
            form.set("userEmail", email);
            form.set("userMobile", mobile);
            form.set("details", details);
            form.set("status", "new");

            // Save the form data to Parse Server
            await form.save();
            setName("");
            setEmail("");
            setMobile("");
            setErrorMessage("Your information has been successfully submitted");
            setDetails("");
          } catch (error: any) {
            console.error("Error submitting form:", error);
            setErrorMessage(error.message);
          } finally {
            setLoading(false);
            // setModal("");
          }
        }
        break;
      default:
        break;
    }
  };

  const formResetHandler = () => {
    // setModal("");
    setName("");
    setEmail("");
    setMobile("");
    setDetails("");
    setErrorMessage("");
  };
  const nameChangeHandler = (event: any) => {
    setName(event.target.value);
  };

  const emailChangeHandler = (event: any) => {
    setEmail(event.target.value);
  };
  const mobileChangeHandler = (event: any) => {
    setMobile(event.target.value);
  };
  const detailsChangeHandler = (event: any) => {
    setDetails(event.target.value);
  };
  const [artworkChange, setArtworkChange] = useState(false);
  const artworkChangeHandler = () => {
    setArtworkChange((current) => !current);
  };
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchArtworks = async () => {
      const query = new Parse.Query("Artwork");
      query.limit(3);
      try {
        const results = await query.find();
        setArtworks(results);

        console.log(results[0].get("images").id);
      } catch (err: any) {
        setErrorMessage(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtworks();
  }, [artworkChange]);
  useEffect(() => {
    const fetchExhibitions = async () => {
      const query = new Parse.Query("Artwall_Exhibition");
      query.limit(4);

      try {
        const results = await query.find();
        setExhibitions(results);
        console.log(results);
      } catch (err: any) {
        setErrorMessage(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchExhibitions();
    const fetchBlogs = async () => {
      const query = new Parse.Query("Blog");
      query.limit(3);

      try {
        const results = await query.find();
        setBlogs(results);
        setBlogItems(
          results.map((blog) => {
            return {
              image: blog.get("thumbnail").url(),
              title: blog.get("title"),
              subtitle: blog.get("publishDate").toDateString(),
              handle: "",
              borderColor: "#3B82F6",
              gradient: "linear-gradient(145deg, #3B82F6, #000)",
              url: `/blog/${blog.id}`,
            };
          }),
        );
        console.log(results);
      } catch (err: any) {
        setErrorMessage(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
    const fetchBasket = async () => {
      const user = Parse.User.current();

      if (user || localStorage.getItem("guestId")) {
        try {
          const basket = await Parse.Cloud.run("getBasket", {
            user: user ? user.id : localStorage.getItem("guestId"),
          });
          if (basket.get("status") !== "completed") setBasket(basket);
          const artworkQuantities: any = {};
          basket
            .get("items")
            .filter(
              (item: any) =>
                item.type === "ArtworkFrame" || item.type === "Artwork",
            )
            .forEach((item: any) => {
              const artworkId = item.artwork.id;
              artworkQuantities[artworkId] =
                (artworkQuantities[artworkId] || 0) + item.quantity;
            });
          setArtworkQuantities(artworkQuantities);
          let totalQuantity = 0;
          basket.get("items").forEach((item: any) => {
            totalQuantity += item.quantity;
          });
          setTotalQuantity(totalQuantity);
          localStorage.setItem("totalQuantity", String(totalQuantity));
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          // setLoading(false);
        }
      }
    };
    fetchBasket();
  }, []);
  useEffect(() => {
    const fetchSlider = async () => {
      const query = new Parse.Query("Slider");
      query.equalTo("page", "landing");
      try {
        const results = await query.find();
        if (results.length > 0) {
          // console.log(results);
          setSlider(results);
        } else {
          throw new Error("Slider not found.");
        }
      } catch (err: any) {
        console.log(err);
        // setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSlider();
  }, []);

  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
    },
  };
  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: (custom: any) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 * custom },
    }),
  };
  const logoList = [
    {
      src: bonhams,
      alt: "bonhams",
      href: "https://www.bonhams.com/",
    },
    {
      src: rws,
      alt: "rws",
      href: "https://www.royalwatercoloursociety.co.uk/rws-gallery-hire",
    },
    {
      src: trailfinders,
      alt: "trailfinders",
      href: "https://ealingtrailfinders.com/",
    },
    {
      src: rosberys,
      alt: "rosberys",
      href: "https://www.roseberys.co.uk/",
    },
    {
      src: ladyki,
      alt: "ladyki",
      // href: "",
    },
    {
      src: dhl,
      alt: "dhl",
      href: "https://www.dhl.com/us-en/home.html?locale=true",
    },
    {
      src: christies,
      alt: "christies",
      href: "https://www.christies.com/en",
    },
    {
      src: ironmaiden,
      alt: "ironmaiden",
      href: "https://www.ironmaiden.com/",
    },
    {
      src: octink,
      alt: "octink",
      href: "https://www.octink.com/",
    },
  ];
  // const blogItems = [

  //   {
  //     image: "https://i.pravatar.cc/300?img=2",
  //     title: "Mike Chen",
  //     subtitle: "Backend Engineer",
  //     handle: "@mikechen",
  //     borderColor: "#10B981",
  //     gradient: "linear-gradient(180deg, #10B981, #000)",
  //     url: "https://linkedin.com/in/mikechen",
  //   },
  // ];
  // useSectionScrollSnap();
  return (
    <Fragment>
      <div className={styles.container}>
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#c8bdb8",
          }}
          className={styles["banner-section"]}
        >
          {slider && slider.length > 1 ? (
            <Fade
              onChange={function noRefCheck() {}}
              onStartChange={function noRefCheck() {}}
              indicators={indicators}
              {...properties}
              duration={6000}
              transitionDuration={800}
            >
              {/* <Grid container sx={{ backgroundColor: "#c8bdb8" }}>
                <Grid item md={6.5} xs={12}>
                  <img
                    src={main_bg}
                    alt="main"
                    className={styles["main-bg"] + " d-none"}
                    onLoad={(event: any) => {
                      event.target.classList.remove("d-none");
                    }}
                  />
                </Grid>
                <Grid
                  item
                  md={5}
                  xs={12}
                  sx={{
                    display: { xs: "flex", md: "block" },
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: { md: 0, xs: 4 },
                    textAlign: { md: "start", xs: "center" },
                  }}
                >
                  {" "}
                  <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                  >
                    <Typography
                      variant="h3"
                      component={"h1"}
                      sx={{ mt: { lg: 17, md: 13 } }}
                    >
                      Start your framing journey
                    </Typography>
                    <Typography
                      variant="h5"
                      component={"h2"}
                      sx={{ fontFamily: "Regular", color: "#863a18" }}
                    >
                      Make your memories immortal
                    </Typography>
                    <Typography sx={{ fontWeight: "bolder" }}>
                      <br />
                      Express framing has never been easier. You can even upload
                      your image for us to print and then view framing option.
                      Click on Start Framing to begin your journey!
                      <br />
                      <br />
                    </Typography>
                    <Box className={styles.buttons}>
                      <Link to={"/framing"}>
                        <button>Online Framing</button>
                      </Link>
                      <Link to={"/shop"}>
                        <button>Buy Artworks</button>
                      </Link>
                    </Box>
                    <Box className={styles.buttons}>
                      <Link
                        to={"/instore-framing"}
                        style={{ display: "block" }}
                      >
                        <button>Instore Framing</button>
                      </Link>
                    </Box>
                  </motion.div>
                </Grid>
              </Grid> */}
              {slider.map((slide: any) => (
                <Grid
                  container
                  sx={{ backgroundColor: "#c8bdb8", height: "100%" }}
                >
                  {slide.get("image") && (
                    <Grid item md={6} xs={12}>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                      >
                        <img
                          src={slide.get("image").url()}
                          alt="main"
                          className={styles["main-bg"]}
                          // onLoad={(event: any) => {
                          //   event.target.classList.remove("d-none");
                          // }}
                        />
                      </motion.div>
                    </Grid>
                  )}
                  <Grid
                    item
                    md={5}
                    xs={12}
                    sx={{
                      display: { xs: "flex", md: "block" },
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      p: { md: 7, xs: 4 },
                      textAlign: { md: "start", xs: "center" },
                      mt: { lg: 17, md: 13 },
                    }}
                  >
                    {" "}
                    <motion.div
                      initial={{ y: 50, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ delay: 0.2, duration: 0.5 }}
                    >
                      <TextType
                        text={
                          slide.get("title")
                          //   [
                          //   "Text typing effect",
                          //   "for your websites",
                          //   "Happy coding!",
                          // ]
                        }
                        typingSpeed={100}
                        pauseDuration={4000}
                        showCursor
                        cursorCharacter="_"
                        startOnVisible={true}
                        // loop={false}
                        // text={[
                        //   "Welcome to React Bits! Good to see you!",
                        //   "Build some amazing experiences!",
                        // ]}
                        // deletingSpeed={50}
                        // variableSpeedEnabled={false}
                        // variableSpeedMin={60}
                        // variableSpeedMax={120}
                        cursorBlinkDuration={0.5}
                      />
                      {/* <Typography
                        variant="h3"
                        component={"h1"}
                        sx={{ mt: { lg: 17, md: 13 } }}
                      >
                        {slide.get("title")}
                      </Typography> */}
                      {/* <Typography
                        variant="h5"
                        component={"h2"}
                        sx={{ fontFamily: "Regular", color: "#863a18" }}
                      >
                        Make your memories immortal
                      </Typography> */}
                      <br />
                      {slide.get("description").map((item: string) => (
                        <Typography sx={{ fontWeight: "bolder", mt: 3 }}>
                          {item}
                          <br />
                        </Typography>
                      ))}
                      <br />
                      {slide.get("buttonTitles") && (
                        <Box className={styles.buttons}>
                          {slide
                            .get("buttonTitles")
                            .map((item: any, ind: number) => {
                              if (ind < 2) {
                                return (
                                  <Link
                                    to={
                                      slide.get("buttonTargets") &&
                                      slide.get("buttonTargets").length > ind
                                        ? slide.get("buttonTargets")[ind]
                                        : ""
                                    }
                                    style={{ display: "block" }}
                                  >
                                    <button>{item}</button>
                                  </Link>
                                );
                              }
                              return <></>;
                            })}
                        </Box>
                      )}{" "}
                      {slide.get("buttonTitles") &&
                        slide.get("buttonTitles").length > 2 && (
                          <Box className={styles.buttons}>
                            {slide
                              .get("buttonTitles")
                              .map((item: any, ind: number) => {
                                if (ind > 1) {
                                  return (
                                    <Link
                                      to={
                                        slide.get("buttonTargets") &&
                                        slide.get("buttonTargets").length > ind
                                          ? slide.get("buttonTargets")[ind]
                                          : ""
                                      }
                                      style={{ display: "block" }}
                                    >
                                      <button>{item}</button>
                                    </Link>
                                  );
                                }
                                return <></>;
                              })}
                          </Box>
                        )}
                    </motion.div>
                  </Grid>
                </Grid>
              ))}
            </Fade>
          ) : slider ? (
            <Grid container sx={{ backgroundColor: "#c8bdb8", height: "100%" }}>
              {slider[0].get("image") && (
                <Grid item md={6} xs={12}>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                  >
                    <img
                      src={slider[0].get("image").url()}
                      alt="main"
                      className={styles["main-bg"]}
                      // onLoad={(event: any) => {
                      //   event.target.classList.remove("d-none");
                      // }}
                    />
                  </motion.div>
                </Grid>
              )}
              <Grid
                item
                md={5}
                xs={12}
                sx={{
                  display: { xs: "flex", md: "block" },
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: { md: 7, xs: 4 },
                  textAlign: { md: "start", xs: "center" },
                  mt: { lg: 17, md: 13 },
                }}
              >
                {" "}
                <motion.div
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                >
                  <TextType
                    text={
                      slider[0].get("title")
                      //   [
                      //   "Text typing effect",
                      //   "for your websites",
                      //   "Happy coding!",
                      // ]
                    }
                    typingSpeed={100}
                    pauseDuration={4000}
                    showCursor
                    cursorCharacter="_"
                    startOnVisible={true}
                    // loop={false}
                    // text={[
                    //   "Welcome to React Bits! Good to see you!",
                    //   "Build some amazing experiences!",
                    // ]}
                    // deletingSpeed={50}
                    // variableSpeedEnabled={false}
                    // variableSpeedMin={60}
                    // variableSpeedMax={120}
                    cursorBlinkDuration={0.5}
                  />
                  {/* <Typography
                        variant="h3"
                        component={"h1"}
                        sx={{ mt: { lg: 17, md: 13 } }}
                      >
                        {slider[0].get("title")}
                      </Typography> */}
                  {/* <Typography
                        variant="h5"
                        component={"h2"}
                        sx={{ fontFamily: "Regular", color: "#863a18" }}
                      >
                        Make your memories immortal
                      </Typography> */}
                  <br />
                  {slider[0].get("description").map((item: string) => (
                    <Typography sx={{ fontWeight: "bolder", mt: 3 }}>
                      {item}
                      <br />
                    </Typography>
                  ))}
                  <br />
                  {slider[0].get("buttonTitles") && (
                    <Box className={styles.buttons}>
                      {slider[0]
                        .get("buttonTitles")
                        .map((item: any, ind: number) => {
                          if (ind < 2) {
                            return (
                              <Link
                                to={
                                  slider[0].get("buttonTargets") &&
                                  slider[0].get("buttonTargets").length > ind
                                    ? slider[0].get("buttonTargets")[ind]
                                    : ""
                                }
                                style={{ display: "block" }}
                              >
                                <button>{item}</button>
                              </Link>
                            );
                          }
                          return <></>;
                        })}
                    </Box>
                  )}{" "}
                  {slider[0].get("buttonTitles") &&
                    slider[0].get("buttonTitles").length > 2 && (
                      <Box className={styles.buttons}>
                        {slider[0]
                          .get("buttonTitles")
                          .map((item: any, ind: number) => {
                            if (ind > 1) {
                              return (
                                <Link
                                  to={
                                    slider[0].get("buttonTargets") &&
                                    slider[0].get("buttonTargets").length > ind
                                      ? slider[0].get("buttonTargets")[ind]
                                      : ""
                                  }
                                  style={{ display: "block" }}
                                >
                                  <button>{item}</button>
                                </Link>
                              );
                            }
                            return <></>;
                          })}
                      </Box>
                    )}
                </motion.div>
              </Grid>
            </Grid>
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "calc( 100vh - 6rem )",
                backgroundColor: "#c8bdb8",
              }}
            >
              .
            </Box>
          )}
        </Box>
        {/* <Grid container sx={{ backgroundColor: "#c8bdb8" }}>
          <Grid item md={6.5} xs={12}>
            <img
              src={main_bg}
              alt="main"
              className={styles["main-bg"] + " d-none"}
              onLoad={(event: any) => {
                event.target.classList.remove("d-none");
              }}
            />
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              display: { xs: "flex", md: "block" },
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { md: 0, xs: 4 },
              textAlign: { md: "start", xs: "center" },
            }}
          >
            {" "}
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              <Typography
                variant="h3"
                component={"h1"}
                sx={{ mt: { lg: 17, md: 13 } }}
              >
                Start your framing journey
              </Typography>
              <Typography
                variant="h5"
                component={"h2"}
                sx={{ fontFamily: "Regular", color: "#863a18" }}
              >
                Make your memories immortal
              </Typography>
              <Typography sx={{ fontWeight: "bolder" }}>
                <br />
                Express framing has never been easier. You can even upload your
                image for us to print and then view framing option. Click on
                Start Framing to begin your journey!
                <br />
                <br />
              </Typography>
              <Box className={styles.buttons}>
                <Link to={"/framing"}>
                  <button>Online Framing</button>
                </Link>
                <Link to={"/shop"}>
                  <button>Buy Artworks</button>
                </Link>
              </Box>
              <Box className={styles.buttons}>
                <Link to={"/instore-framing"} style={{ display: "block" }}>
                  <button>Instore Framing</button>
                </Link>
              </Box>
            </motion.div>
          </Grid>
        </Grid> */}
        <Grid
          container
          sx={{
            backgroundColor: "#dfdfdf",
          }}
          className={styles["banner-section"]}
        >
          <Grid item xs={12} md={6.5} sx={{ display: "flex" }}>
            <img
              src={framing}
              alt="framing"
              className={styles.framing + " d-none"}
              onLoad={(event: any) => {
                event.target.classList.remove("d-none");
              }}
            />
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              display: { xs: "flex", md: "block" },
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { md: 0, xs: 4 },
              textAlign: { md: "start", xs: "center" },
              pb: 10,
            }}
          >
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Typography
                variant="h3"
                component={"h1"}
                sx={{ mt: { lg: 10, md: 3 } }}
              >
                Framing
              </Typography>
              <Typography sx={{ fontWeight: "bolder" }}>
                <br />
                In our showroom, we have over 700 diifferent typesof frames, as
                well as a large selection of mountboards and glass. There's a
                frame to suit every taste.<br></br>
                <br></br>
                We have gathered our best-selling frames and mounts so you can
                experiment with different combination for your artwork.<br></br>
                <br></br>
                Visit our showroom today or click on online framing to get
                started.
                <br />
                <br />
              </Typography>
              <div className={styles.buttons}>
                <Link to={"/framing"}>
                  <button>Online Framing</button>
                </Link>
                <Link to={"/instore-framing"}>
                  <button>Instore Framing</button>
                </Link>
              </div>
            </motion.div>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            backgroundColor: "#dfdfdf",
          }}
          className={styles["banner-section"]}
        >
          <Grid item xs={12} md={6.5} sx={{ display: "flex" }}>
            <img
              src={printing}
              data-src={printing}
              alt="printing"
              className={styles.printing + " d-none"}
              onLoad={(event: any) => {
                event.target.classList.remove("d-none");
              }}
            />
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              display: { xs: "flex", md: "block" },
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { md: 0, xs: 4 },
              textAlign: { md: "start", xs: "center" },
            }}
          >
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Typography
                variant="h3"
                component={"h1"}
                sx={{ mt: { lg: 10, md: 3 } }}
              >
                Printing
              </Typography>
              <Typography sx={{ fontWeight: "bolder" }}>
                <br />
                Professional printing for both artists and photographers. We use
                the latest 12 colour pigment UltraChrome printing technology to
                bring your photos to life. Our giclee prints have the highest
                colour density and resolution possible. We offer a selection of
                fine art and photographic papers to ensure the best finish for
                your image.
                <br />
                <br /> Get started by uploading your photo.
                <br />
                <br />
              </Typography>
              <div className={styles.buttons}>
                <Link to={"/upload"}>
                  <button>Upload photo</button>
                </Link>
                <Link to={"/printing"}>
                  <button>Learn more</button>
                </Link>
              </div>
            </motion.div>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            backgroundColor: "#dfdfdf",
          }}
          className={styles["banner-section"]}
        >
          <Grid item xs={12} md={6.5} sx={{ display: "flex" }}>
            <img
              src={memorabilia}
              data-src={memorabilia}
              alt="memoribilia"
              className={styles.memorabilia}
              onLoad={(event: any) => {
                event.target.classList.remove("d-none");
              }}
            />
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              display: { xs: "flex", md: "block" },
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { md: 0, xs: 4 },
              textAlign: { md: "start", xs: "center" },
            }}
          >
            {" "}
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Typography
                variant="h3"
                component={"h1"}
                sx={{ mt: { lg: 10, md: 3 } }}
              >
                Memorabilia
              </Typography>
              <Typography sx={{ fontWeight: "bolder" }}>
                <br />
                We are proud to have an expert team dedicated to framing your
                special memorabilia. Our team has been thrilled to work with
                stadiums, sport collectors, football and rugby clubs to present
                and protect their special memorabilia.
                <br />
                <br />
                From jersey shirts to sport gear and miniature models, we have
                framed them all. We understand how precious your memorabilia are
                and our team will always do their best to create unique designs
                matching your taste. Both presentation and protection of your
                memorabilia are always prioritised.
                <br />
                <br />
              </Typography>
              <div className={styles.buttons}>
                <Link to={"/memorabilia"}>
                  <button>Learn more</button>
                </Link>
              </div>
            </motion.div>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            backgroundColor: "#dfdfdf",
          }}
          className={styles["banner-section"]}
        >
          <Grid item xs={12} md={6.5} sx={{ display: "flex" }}>
            <img
              src={exhibition}
              data-src={exhibition}
              alt="exhibition"
              className={styles.exhibition}
              onLoad={(event: any) => {
                event.target.classList.remove("d-none");
              }}
            />
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              display: { xs: "flex", md: "block" },
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { md: 0, xs: 4 },
              textAlign: { md: "start", xs: "center" },
            }}
          >
            {" "}
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Typography
                variant="h3"
                component={"h1"}
                sx={{ mt: { lg: 10, md: 3 } }}
              >
                Exhibition
              </Typography>
              <Typography sx={{ fontWeight: "bolder" }}>
                <br />
                We are proud to have organised over 269 solo and group
                exhibitions all around the world promoting both merging talented
                and established artists. With over three decades of experience
                our team has worked closely with collectors, auctioneers and
                buyers to
                <br />
                <br />
              </Typography>
              <div className={styles.buttons}>
                <Link to={"/gallery"}>
                  <button>View Exhibition</button>
                </Link>
              </div>
            </motion.div>
          </Grid>
        </Grid>
        <Container>
          <Grid container spacing={7} sx={{ textAlign: "center", py: 4 }}>
            <Grid item xs={12} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={satisfaction}
                  alt="satisfaction"
                  className={styles.icons}
                />
                <Typography variant="subtitle1">
                  Satisfaction Guaranteed
                </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  100% guaranteed satisfaction. We go above and beyond to make
                  you happy with our service, and your satisfaction is our goal.
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img src={delivery} alt="delivery" className={styles.icons} />
                <Typography variant="subtitle1">Reliable Delivery </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  Reliable and express delivery service national wide
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img src={customer} alt="customer" className={styles.icons} />
                <Typography variant="subtitle1">
                  Great Customer Service
                </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  Constantly improving our services to make it easier for you to
                  have a more enjoyable experience coing our services
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img src={trusted} alt="trusted" className={styles.icons} />
                <Typography variant="subtitle1">
                  Trusted by Professionals
                </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  Working with the bests in the field of art and framing has
                  made us an attractive choice for collectors, auctioneers and
                  art enthusiasts
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        </Container>

        <Box
          sx={{
            backgroundColor: "#dad9da",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Container sx={{ my: 3 }}>
            <Typography
              variant="h3"
              component={"h1"}
              sx={{ marginBottom: 3, color: "#863a18" }}
            >
              Blog
            </Typography>
            {blogs && (
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <ChromaGrid
                  items={blogItems}
                  radius={300}
                  damping={0.45}
                  fadeOut={0.6}
                  ease="power3.out"
                />
              </Grid>
            )}
            <Box
              className={styles.buttons}
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: { xs: "10rem", sm: "2rem" },
              }}
            >
              <Link to={"/blogs"}>
                <button>View more</button>
              </Link>
            </Box>
          </Container>
        </Box>
        <Container className={styles.upcoming}>
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mt: 8,
              }}
              spacing={0}
            >
              <Grid
                item
                xs={12}
                md={9.8}
                // lg={10}
                sx={{
                  display: { xs: "flex", md: "block" },
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  textAlign: { xs: "center", md: "start" },
                }}
              >
                <Box
                  component={"span"}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box component={"span"}>
                    <Typography variant="h4" component={"h1"}>
                      Upcoming
                    </Typography>
                    <Typography variant="h5" component={"h2"}>
                      Exhibition on
                    </Typography>
                  </Box>
                  <img
                    src={artwall}
                    alt="Art Wall"
                    className={styles.artwall}
                  />
                </Box>
                <h5>
                  The steps we take to promote talented artist. We have recently
                  introduced Art Wall which is project that focuses introducing
                  talented and emerging artist in the beating heart of London
                  -Faam Gallery. Every two weeks, a new artist is promoted.
                </h5>
                <Box className={styles.buttons}>
                  <Link to={"/gallery"}>
                    <button>View All Exhibitions</button>
                  </Link>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={2.2}
                // lg={2}
                sx={{
                  display: { xs: "flex", md: "block" },
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  textAlign: { xs: "center", md: "start" },
                }}
              >
                <Typography component="h2" variant="h4" color="#949494" my={2}>
                  Interested in <br></br>Exhibiting?
                </Typography>
                <Box
                  className={styles.buttons}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <button onClick={handleOpen} id="Artist Application">
                    Apply as an artist
                  </button>
                  <button onClick={handleOpen} id="Collector Application">
                    Apply as a collector
                  </button>
                </Box>
                <Backdrop
                  sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                  })}
                  open={modal === "" ? false : true}
                  // onClick={handleClose}
                >
                  {modal === "Artist Application" ? (
                    <Grid
                      sx={{
                        backgroundColor: "white",
                        width: { xs: "95vw", sm: "38rem" },
                        height: { xs: "42rem", sm: "40rem" },
                        display: "flex",
                        justifyContent: "space-between",
                        // alignItems: "center",
                        color: "black",
                        py: { sm: 5, xs: 2 },
                        px: { sm: 8, xs: 4 },
                        position: "relative",
                      }}
                      container
                    >
                      <button
                        style={{
                          position: "absolute",
                          right: "3rem",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                          top: "3rem",
                        }}
                        onClick={handleClose}
                      >
                        <ClearIcon />
                      </button>
                      <Grid item xs={12}>
                        <Typography component="h2" variant="h4">
                          Get in touch
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={5.5}>
                        <label htmlFor="name">Full Name*</label>
                        <input
                          className={styles.input}
                          placeholder="John Smith"
                          name="name"
                          onChange={nameChangeHandler}
                          value={name}
                        />
                      </Grid>

                      <Grid item xs={12} sm={5.5}>
                        <label htmlFor="email">Email*</label>
                        <input
                          className={styles.input}
                          placeholder="johnsmith@gmail.com"
                          name="email"
                          type="email"
                          onChange={emailChangeHandler}
                          value={email}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5.5}>
                        <label htmlFor="mobile">Mobile*</label>
                        <input
                          className={styles.input}
                          placeholder="07400000000"
                          name="mobile"
                          type="tel"
                          onChange={mobileChangeHandler}
                          value={mobile}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <label htmlFor="About-me">About me</label>
                        <textarea
                          className={styles.input}
                          placeholder=""
                          name="About-me"
                          rows={8}
                          onChange={detailsChangeHandler}
                          value={details}
                        />
                      </Grid>
                      {/* Apply as an artist: About me
                    Apply as a collector: Enquiry */}
                      <Grid item xs={12}>
                        <button
                          className={styles["edit-button"]}
                          style={{ width: "10rem", marginRight: "10px" }}
                          onClick={formSubmitHandler}
                          id="project"
                        >
                          Submit
                        </button>
                        <button
                          className={styles["edit-button"]}
                          onClick={formResetHandler}
                          id="project"
                        >
                          Reset
                        </button>
                        <br />
                        <br />
                        <Typography>{errorMessage}</Typography>
                      </Grid>
                    </Grid>
                  ) : modal === "Collector Application" ? (
                    <Grid
                      sx={{
                        backgroundColor: "white",
                        width: { xs: "95vw", sm: "38rem" },
                        height: { xs: "42rem", sm: "40rem" },
                        display: "flex",
                        justifyContent: "space-between",
                        // alignItems: "center",
                        color: "black",
                        py: { sm: 5, xs: 2 },
                        px: { sm: 8, xs: 4 },
                        position: "relative",
                      }}
                      container
                    >
                      <button
                        style={{
                          position: "absolute",
                          right: "3rem",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                          top: "3rem",
                        }}
                        onClick={handleClose}
                      >
                        <ClearIcon />
                      </button>
                      <Grid item xs={12}>
                        <Typography component="h2" variant="h4">
                          Get in touch
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={5.5}>
                        <label htmlFor="name">Full Name*</label>
                        <input
                          className={styles.input}
                          placeholder="John Smith"
                          name="name"
                          onChange={nameChangeHandler}
                          value={name}
                        />
                      </Grid>

                      <Grid item xs={12} sm={5.5}>
                        <label htmlFor="email">Email*</label>
                        <input
                          className={styles.input}
                          placeholder="johnsmith@gmail.com"
                          name="email"
                          type="email"
                          onChange={emailChangeHandler}
                          value={email}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5.5}>
                        <label htmlFor="mobile">Mobile*</label>
                        <input
                          className={styles.input}
                          placeholder="07400000000"
                          name="mobile"
                          type="tel"
                          onChange={mobileChangeHandler}
                          value={mobile}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <label htmlFor="Enquiry">Enquiry</label>
                        <textarea
                          className={styles.input}
                          placeholder=""
                          name="Enquiry"
                          rows={12}
                          onChange={detailsChangeHandler}
                          value={details}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <button
                          className={styles["edit-button"]}
                          style={{ width: "10rem", marginRight: "10px" }}
                          onClick={formSubmitHandler}
                          id="project"
                        >
                          Submit
                        </button>
                        <button
                          className={styles["edit-button"]}
                          onClick={formResetHandler}
                          id="project"
                        >
                          Reset
                        </button>
                        <br />
                        <br />
                        <Typography>{errorMessage}</Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    ""
                  )}
                </Backdrop>
              </Grid>
            </Grid>
          </motion.div>
          {exhibitions && (
            <Grid
              container
              marginBottom={4}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {exhibitions.map((exhibition, ind) => (
                <Link to={`/gallery/exhibition/${exhibition.id}`}>
                  <Grid item xs={12} sm={5.8} md={2.8}>
                    <motion.div
                      variants={scaleVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.5 }}
                      custom={ind + 1}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: 1,
                          // backgroundColor: "black",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={exhibition.get("thumbnail").url()}
                          alt={exhibition.get("title")}
                          style={{ width: "100%", aspectRatio: 1 }}
                        />
                      </Box>
                      <Typography component="h2" variant="h5">
                        {exhibition.get("title")}
                      </Typography>
                      <Typography variant="h6" sx={{ color: "#949494" }}>
                        Until {exhibition.get("endDate").toDateString()}
                      </Typography>
                    </motion.div>
                  </Grid>
                </Link>
              ))}
            </Grid>
          )}
        </Container>
        <Box sx={{ width: "100%", backgroundColor: "#330101" }}>
          <Container>
            <Grid container pb={5} spacing={5} mt={2}>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <motion.div
                  variants={textVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <Typography
                    component={"h1"}
                    sx={{ color: "white", textAlign: "center" }}
                    variant="h3"
                  >
                    Faam Gallery Aim
                  </Typography>
                  <Typography sx={{ color: "white", textAlign: "center" }}>
                    <br />
                    One of the most important aims of Faam Gallery is promoting
                    both talented and professional artists on an international
                    level to a wide audience. We aim to promote Asian and
                    European arts as well as holding cultural art festivals,
                    biennials and exhibitions.
                  </Typography>
                </motion.div>
              </Grid>
              <Grid item xs={12} md={6}>
                <video id="video" className={styles.video} controls>
                  <source src={video} />
                </video>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <img
          src={panorama}
          alt="Faam Gallery Interior View"
          className={styles.panorama}
        />
        <Box sx={{ width: "100%", backgroundColor: "#f6f6f6a4" }}>
          <Container sx={{ py: 4 }}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                sx={{ textAlign: { xs: "center", md: "start" } }}
              >
                <Typography variant="h3" component={"h1"}>
                  Featured Artworks
                </Typography>
                <Link to={"/shop"}>
                  <Typography
                    sx={{
                      my: { xs: 2, ms: 5 },
                      display: "block",
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "black",
                    }}
                    variant="h6"
                    color="inherit"
                  >
                    View the full collection
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12} md={9}>
                <Grid container spacing={2}>
                  {artworks &&
                    artworks.map((artwork: any) => (
                      <ArtworkCard
                        artwork={artwork}
                        artworkChangeHandler={artworkChangeHandler}
                        basket={basket}
                        artworkQuantities={artworkQuantities}
                        grid={4}
                      />
                    ))}
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid container sx={{ mt: 5 }}>
              <Grid
                item
                xs={12}
                md={3}
                sx={{ textAlign: { xs: "center", md: "start" } }}
              >
                <Typography variant="h3" component={"h1"}>
                  Sale
                </Typography>
                <Link to={"/shop"}>
                  <Typography
                    sx={{
                      my: { xs: 2, ms: 5 },
                      display: "block",
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "black",
                    }}
                    variant="h6"
                    color="inherit"
                  >
                    View the full collection
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12} md={9}>
                <Grid container spacing={3}>
                  {artworks &&
                    artworks.map((artwork: any) => (
                      <ArtworkCard
                        artwork={artwork}
                        artworkChangeHandler={artworkChangeHandler}
                        basket={basket}
                        artworkQuantities={artworkQuantities}
                        grid={4}
                      />
                    ))}
                </Grid>
              </Grid>
            </Grid> */}
          </Container>
        </Box>
        <Container>
          <Grid container sx={{ py: 5, justifyContent: "space-between" }}>
            <Grid
              xs={12}
              md={12}
              sx={{ textAlign: { xs: "center", md: "start" } }}
            >
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography
                  variant="h3"
                  component={"h1"}
                  sx={{ marginBottom: 4 }}
                >
                  Our Clients
                </Typography>
                <Typography variant="h6">
                  Don't just take our word for it! We have worked with over 400
                  artists and have served over thousands of customers over the
                  years. We are proud to have worked with a plethora of
                  businesses and big names
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <div
                style={{
                  height: "200px",
                  position: "relative",
                  overflow: "hidden",
                  marginTop: "3rem",
                }}
              >
                <LogoLoop
                  logos={logoList}
                  speed={80}
                  direction="left"
                  logoHeight={60}
                  gap={60}
                  hoverSpeed={0}
                  scaleOnHover
                  fadeOut
                  fadeOutColor="#ffffff"
                  ariaLabel="Our Clients"
                />
              </div>
              {/* <Grid container alignItems={"center"}>
                <Grid
                  item
                  xs={4}
                  className={styles.client}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Link to={"https://www.bonhams.com/"} target="blank">
                    <img src={bonhams} alt="bonhams" />
                  </Link>
                </Grid>
                <Grid item xs={4} className={styles.client}>
                  <Link
                    to={
                      "https://www.royalwatercoloursociety.co.uk/rws-gallery-hire"
                    }
                    target="blank"
                  >
                    <img src={rws} alt="rws" />
                  </Link>
                </Grid>
                <Grid item xs={4} className={styles.client}>
                  <Link to={"https://ealingtrailfinders.com/"} target="blank">
                    <img src={trailfinders} alt="trailfinders" />
                  </Link>
                </Grid>
              </Grid>
              <Grid container alignItems={"center"}>
                <Grid item xs={4} className={styles.client}>
                  <Link to={"https://www.roseberys.co.uk/"} target="blank">
                    <img src={rosberys} alt="rosberys" />
                  </Link>
                </Grid>
                <Grid item xs={4} className={styles.client}>
                  <img src={ladyki} alt="ladyki" />
                </Grid>
                <Grid item xs={4} className={styles.client}>
                  <Link
                    to={"https://www.dhl.com/us-en/home.html?locale=true"}
                    target="blank"
                  >
                    <img src={dhl} alt="dhl" />
                  </Link>
                </Grid>
              </Grid>
              <Grid container alignItems={"center"}>
                <Grid item xs={4} className={styles.client}>
                  <Link to={"https://www.christies.com/en"} target="blank">
                    <img src={christies} alt="christies" />
                  </Link>
                </Grid>
                <Grid item xs={4} className={styles.client}>
                  <Link to={"https://www.ironmaiden.com/"} target="blank">
                    <img src={ironmaiden} alt="ironmaiden" />
                  </Link>
                </Grid>
                <Grid item xs={4} className={styles.client}>
                  <Link to={"https://www.octink.com/"} target="blank">
                    <img src={octink} alt="octink" />
                  </Link>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>
        </Container>
      </div>
    </Fragment>
  );
};

export default Landing;
{
  /* xl lg md sm xs */
}
